// Futbol pozisyonları ve Türkçe karşılıkları
export const POSITIONS = [
  // Kaleciler
  { value: "goalkeeper", label: "Kaleci", category: "Kaleci" },
  { value: "sweeper-keeper", label: "Pasor Kaleci", category: "Kaleci" },
  
  // Defans
  { value: "left-back", label: "Sol Bek", category: "Defans" },
  { value: "left-center-back", label: "Sol Stoper", category: "Defans" },
  { value: "right-center-back", label: "Sağ Stoper", category: "Defans" },
  { value: "right-back", label: "Sağ Bek", category: "Defans" },
  { value: "sweeper", label: "Ön Libero", category: "Defans" },
  { value: "left-wing-back", label: "Sol Kanat Bek", category: "Defans" },
  { value: "right-wing-back", label: "Sağ Kanat Bek", category: "Defans" },
  
  // Orta Saha
  { value: "left-central-midfielder", label: "Sol İç Orta Saha", category: "Orta Saha" },
  { value: "central-midfielder", label: "Merkez Orta Saha", category: "Orta Saha" },
  { value: "right-central-midfielder", label: "Sağ İç Orta Saha", category: "Orta Saha" },
  { value: "deep-lying-playmaker", label: "Regista (Oyun Kurucu)", category: "Orta Saha" },
  { value: "attacking-midfielder", label: "On Numara", category: "Orta Saha" },
  
  // Kanatlar
  { value: "left-winger", label: "Sol Kanat", category: "Kanat" },
  { value: "right-winger", label: "Sağ Kanat", category: "Kanat" },
  
  // Forvetler
  { value: "left-forward", label: "Sol Kanat Forvet", category: "Forvet" },
  { value: "right-forward", label: "Sağ Kanat Forvet", category: "Forvet" },
  { value: "second-striker", label: "İkinci Forvet", category: "Forvet" },
  { value: "center-forward", label: "Santrafor (Pivot)", category: "Forvet" },
  { value: "false-nine", label: "Gizli Forvet (Sahte 9)", category: "Forvet" },
  
  // Yedek
  { value: "substitute", label: "Yedek", category: "Yedek" }
];

export const getPositionLabel = (positionValue) => {
  const position = POSITIONS.find(p => p.value === positionValue);
  return position ? position.label : positionValue;
};

export const getPositionsByCategory = () => {
  const categories = {};
  POSITIONS.forEach(pos => {
    if (!categories[pos.category]) {
      categories[pos.category] = [];
    }
    categories[pos.category].push(pos);
  });
  return categories;
};
